import { apiRequest } from "../index";


async function getLatLong(locationName) {
  const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(locationName)}`;

  const res = await fetch(url, {
    headers: {
      "User-Agent": "YourAppName"  // required
    }
  });

  const data = await res.json();

  if (data.length === 0) {
    return { error: "Location not found" };
  }

  return {
    latitude: data[0].lat,
    longitude: data[0].lon,
    displayName: data[0].display_name
  };
}





export const getRestaurantsOrHotels = async ({
  hotels = false,
  page = 1,
  limit = 10,
  longitude,
  cuisineType,
  foodType,
  latitude,
  rating,
  food,
  filterType,
  address = "",
  location,
  features = "",
  min = "",
  max = "",
  search,
  distance = ""
}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("hotels", hotels);
  queryParams.append("page", page);
  queryParams.append("limit", limit);

  if (longitude) queryParams.append("longitude", longitude);
  if (latitude) queryParams.append("latitude", latitude);
  if (rating) queryParams.append("rating", rating);
  if (address) queryParams.append("address", address);
  if (features) queryParams.append("features", features);
  if (min !== "") queryParams.append("min", min);
  if (max !== "") queryParams.append("max", max);
  if (foodType) queryParams.append("foodType", foodType);
  if (cuisineType) queryParams.append("cuisineType", cuisineType);
  if (search) queryParams.append("search", search);
  if (location) queryParams.append("location", location);
  if (food) queryParams.append("food", food);
  if (distance !== "") queryParams.append("distance", distance);
 if (location) {
   const loc= await getLatLong(location)
   console.log(loc,'locloclocloc');
   queryParams.append("longitude", loc.longitude);
   queryParams.append("latitude", loc.latitude);

 }

  return apiRequest(`/api/user/listings?${queryParams.toString()}`, "GET");
};

export const getLocations = async ({
  hotels,
  restaurants
}) => {
  return apiRequest(`/api/user/locations?hotels=${hotels}&restaurants=${restaurants}`, "GET");
};

